import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ArrowForward, CheckCircle } from '@mui/icons-material';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useCurrentuser } from '@uplift/contexts';
import { useIsMobile } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';
import { Link } from 'react-router-dom';
import { StickyButton } from '../../components';

export const KeepGoing: React.VFC = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile('sm');
  const me = useCurrentuser();

  return (
    <Box className={isMobile ? classes.mobile : classes.desktop}>
      <Box className={classes.content}>
        <CheckCircle className={classes.icon} />
        <Typography variant="h6">
          Password set for {me?.email}
        </Typography>
        <Typography>
          Need to change? You can reset your password next time you login after completing Account Setup.
        </Typography>
        <StickyButton hideBorder centerButtons>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<ArrowForward />}
            component={Link}
            to={ROUTING_CONFIG.onboardingGeneral}
          >
            Next
          </Button>
        </StickyButton>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  content: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    maxWidth: '362px',
    textAlign: 'center',
    width: '100%'
  },
  desktop: {
    display: 'grid',
    placeItems: 'center',
    width: '100%',
  },
  icon: {
    color: theme.palette.success.main,
    height: '50px',
    width: '50px',
  },
  mobile: {
    display: 'grid',
    placeItems: 'center',
    width: '100%',
  }
}));
